export default {
	lang: 'es',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"IA de VORMOR",
		"nav2":"Seguridad de la cuenta",
		"nav3":"Mi disco en la nube",
		"nav4":"Finalizar la sesión",
		"nav5":"Acceso",
		"nav6":"Espacio en la nube",
		"nav7":"Modelo grande de ChatGPT",
		"nav8":"Sistema de grabadora de voz inteligente en la nube",
		"nav_phone_number_code":'Número de teléfono móvil',
		"nav_update":'Cambiar',
		"nav_bind":'Vincular',
		"nav_phone_code_tips":'Para confirmar que es usted quien está operando, complete la verificación de identidad mediante el código de verificación de teléfono',
		"nav_phone_number":'Número de teléfono',
		"nav_phone_number_verify":'Cambiar de verificación de número de teléfono',
		"nav_phone_email_verify":'Cambiar verificación de correo',
		"nav_set_phone_number":'Establecer nuevo número de teléfono',
		"nav_verify_login":'Verificar inicio de sesión',
		"nav_phone_email":'Correo electrónico/Número de teléfono',
		"nav_phone_login":'Inicio de sesión con verificación por teléfono',
		"nav_email_login":'Inicio de sesión con verificación de correo',
		"nav_email_fail":'El formato del correo electrónico es incorrecto, por favor inténtelo de nuevo',
		"nav_pw_fail":'El formato de la contraseña es incorrecto, por favor inténtelo de nuevo',
		"nav_code_fail":'Código de verificación incorrecto',
		"nav_phone_fail":'El formato del número de teléfono es incorrecto, por favor inténtelo de nuevo',
		"nav_input_fail":'Por favor, ingrese su correo electrónico',
		"nav_input_phone":'Ingrese su número de teléfono',
		"nav_phone_verify_back":'Recuperar con verificación de móvil',
		"nav_email_verify_back":'Recuperar mediante verificación de correo'
	},
	login: {
		"login1":"Iniciar sesión con contraseña",
		"login2":"Inicio de sesión por SMS",
		"loginTab3":"Inicio de sesión por correo electrónico",
		"login3":"Correo",
		"login4":"Contraseña de inicio de sesión",
		"login5":"Número de teléfono",
		"login6":"Por favor seleccione",
		"login7":"Código de verificación móvil",
		"login8":"Acceso",
		"login9":"Olvidé la contraseña",
		"login10":"registro",
		"login11":"Al iniciar sesión, aceptas",
		"login12":"Acuerdo de servicio",
		"login13":"política de privacidad",
		"login14":"Conseguir",
		"login15":"Porcelana",
		"login16":"Por favor ingrese su número de cuenta",
		"login17":"Por favor, introduzca su contraseña",
		"login18":"¡Inicio de sesión exitoso!",
		"login19":"¡Por favor ingrese el código de verificación!",
		"login20":"¡Enviado exitosamente!",
		"login21":"y",
		"login22":"Disco en la nube de grabadora de voz",
		"login23":"Mi escritura",
		"login24":"Mi conversación",
		"login25":"Seguridad de la cuenta",
		"login26":"Finalizar la sesión",
		"login27":"Recuperar contraseña por correo electrónico",
		"login28":"Correo",
		"login29":"Código de verificación de correo electrónico",
		"login30":"Establecer una contraseña de inicio de sesión (6-16 caracteres)",
		"login31":"Vuelva a ingresar su contraseña de inicio de sesión",
		"login32":"entregar",
		"login33":"Volver al inicio de sesión",
		"login34":"¡Modificación exitosa!",
	},
	register: {
		"register1":"Número de teléfono",
		"register2":"Por favor ingrese su número de teléfono",
		"register3":"Por favor seleccione",
		"register4":"Código de verificación móvil",
		"register5":"Establecer contraseña",
		"register6":"Por favor, introduzca el código de verificación",
		"register7":"6-16 caracteres",
		"register8":"Confirmación de contraseña",
		"register9":"Correo",
		"register10":"Por favor, introduzca su dirección de correo electrónico",
		"register11":"Código de verificación de correo electrónico",
		"register12":"Por favor, introduzca el código de verificación",
		"register13":"He leído y estoy de acuerdo",
		"register14":"Por favor, lea y marque la casilla que acepta el acuerdo.",
		"register15":"El formato del número de teléfono es incorrecto/el número de teléfono ha sido registrado",
		"register16":"Error del código de verificación móvil",
		"register17":"Ingrese su dirección de correo electrónico / El formato de la dirección de correo electrónico es incorrecto",
		"register18":"Error de formato de correo electrónico",
		"register19":"Error en el código de verificación de correo electrónico",
		"register20":"Establezca la contraseña entre 6 y 16 caracteres.",
		"register21":"Error de formato de contraseña",
		"register22":"Las contraseñas que ingresó dos veces no coinciden. Vuelva a ingresarlas.",
		"register23":"Por favor, introduzca su contraseña",
		"register24":"¡Registro exitoso!",
		"register25":"Error de código de verificación",
	},
	recorder:{
		"recorder1":"Disco en la nube de grabadora de voz",
		"recorder2":"Capacidad de espacio en la nube",
		"recorder3":"documento",
		"recorder331":"Papelera de reciclaje",
		"recorder332":"Borrar todo",
		"recorder4":"nombre",
		"recorder5":"Duración del audio",
		"recorder6":"Tamaño del archivo",
		"recorder7":"Tiempo de creación",
		"recorder8":"funcionar",
		"recorder9":"Descripción del espacio en la nube",
		"recorder10":"documento",
		"recorder11":"Archivo OCR",
		"recorder12": '1. uso del espacio en la nube',
		"recorder13": 'después de guardar grabaciones y notas manuscritas en un cuaderno de oficina inteligente y un bolígrafo de grabación, puede subir al disco en la nube, incluso si el dispositivo inteligente no está cerca, puede entrar en el espacio en la nube para ver el archivo de notas. ',
		"recorder14": '2. ¿ cómo cargar el espacio en la nube? ',
		"recorder15": 'pluma de grabación: ingrese al dispositivo [mi archivo] → haga clic en la operación por lotes → haga clic en "cargar" para agregar el archivo a la cola de carga en la nube y subirlo al espacio en la nube. ',
		"recorder16": 'smart Office book:',
		"recorder17": 'método 1: presione largo en la lista de notas, seleccione las notas que necesita cargar por lotes → haga clic en "sincronizar" para completar la carga; ',
		"recorder171": 'método dos: abra la página de detalles de una sola nota → haga clic en [más - sincronizar] para subir la nota al espacio en la nube. ',
		"recorder18":"No transcrito",
		"recorder19":"Ver resumen",
		"recorder20":"Vocero",
		"recorder21":"Editar el nombre del orador",
		"recorder22":"Seguro",
		"recorder23":"descargar",
		"recorder24":"Descargar contenido:",
		"recorder25":"Configuración de descarga:",
		"recorder26":"Mostrar orador",
		"recorder27":"Cancelar",
		"recorder28":"Compartir enlaces",
		"recorder29":"Cualquiera que obtenga el enlace puede acceder. Es solo para lectura y tiene una validez de 7 días.",
		"recorder30":"Copiar enlace",
		"recorder31":"Escanee y visualice rápidamente",
		"recorder32":"Organización inteligente",
		"recorder33":"Diferenciar entre hablantes",
		"recorder34":"Distinguir inteligentemente el texto transcrito según el rol del hablante",
		"recorder35":"Regularización inteligente del lenguaje hablado",
		"recorder36":"Filtra automáticamente partículas modales, palabras repetidas y palabras de pausa.",
		"recorder37":"Filtrado no vocal",
		"recorder38":"Salta automáticamente el audio sin voz ni ruido durante la reproducción",
		"recorder39":"Por favor seleccione",
		"recorder40":"documento",
		"recorder41":"Audio",
		"recorder42":"Documentos + Audio",
		"recorder43":"pista",
		"recorder44":"Esta operación eliminará archivos, ¿desea continuar?",
		"recorder441":"Esta operación eliminará todos los archivos, ¿desea continuar?",
		"recorder45":"Seguro",
		"recorder46":"Cancelar",
		"recorder47":"¡Eliminado exitosamente!",
		"recorder48":"No eliminado",
		"recorder49":"No hay etiquetas todavía",
		"recorder50":"Ahorro...",
		"recorder51":"Papelera de reciclaje",
	},
	personal: {
		"personal1":"Configuraciones de la cuenta",
		"personal2":"información personal",
		"personal3":"avatar",
		"personal4":"Subir archivos",
		"personal5":"Admite estilos JPG, JPEG, GIF, PNG, admite imágenes de hasta 2 M",
		"personal6":"Apodo",
		"personal7":"Por favor ingrese su apodo",
		"personal8":"género",
		"personal9":"caballeros",
		"personal10":"Extrañar",
		"personal11":"Confidencialidad",
		"personal12":"Cumpleaños",
		"personal13":"Por favor seleccione su fecha de nacimiento",
		"personal14":"Profesión",
		"personal15":"Por favor seleccione su ocupación",
		"personal16":"Por favor ingrese su ocupación (opcional)",
		"personal17":"nación",
		"personal18":"Por favor seleccione su país",
		"personal19":"mantener",
		"personal20":"información personal",
		"personal21":"Seguridad de la cuenta",
		"personal22":"Solo admite imágenes de hasta 2 M",
		"personal23":"¡Subida exitosamente!",
		"personal24":"¡Modificación exitosa!",
		"personal25":"Seguridad de la cuenta",
		"personal26":"Contraseña de inicio de sesión",
		"personal27":"Revisar",
		"personal28":"Correo electrónico",
		"personal29":"reemplazar",
		"personal30":"Cancelación de cuenta",
		"personal32":"¿Está seguro de que desea cancelar su cuenta?",
		"personal33":"Después de cerrar la sesión, se borrará todo el contenido de su cuenta, así que proceda con precaución.",
		"personal34":"Cancelar",
		"personal35":"Seguro",
		"personal36":"Autenticación",
		"personal37":"Para confirmar que es usted quien está haciendo esto, complete la verificación de identidad mediante el código de verificación de correo electrónico.",
		"personal38":"Correo",
		"personal39":"Código de verificación",
		"personal40":"Por favor, introduzca el código de verificación",
		"personal41":"Siguiente paso",
		"personal42":"Configurar un nuevo buzón de correo",
		"personal43":"Correo",
		"personal44":"Por favor, introduzca una nueva dirección de correo electrónico",
		"personal45":"Código de verificación",
		"personal46":"Por favor, introduzca el código de verificación",
		"personal47":"Seguro",
		"personal48":"Establecer una nueva contraseña de inicio de sesión",
		"personal49":"Nueva contraseña de inicio de sesión",
		"personal50":"Por favor ingrese una nueva contraseña",
		"personal51":"Confirmar nueva contraseña",
		"personal52":"Por favor ingrese su nueva contraseña nuevamente",
		"personal53":"Seguro",
		"personal54":"Conseguir",
		"personal55":"Error de formato de correo electrónico",
		"personal56":"¡Reemplazo exitoso!",
		"personal57":"Establezca la contraseña entre 6 y 16 caracteres.",
		"personal58":"Las contraseñas ingresadas dos veces no coinciden",
		"personal59":"¡Modificación exitosa!",
		"personal60":"¡Cierre de sesión exitoso!",
		
		"share_url": "Compartir enlace",
		"share_url_7_day": "El enlace para compartir es válido por 7 días. Antes de que caduque, cualquier persona que lo obtenga podrá acceder a él.",
		"share_audio": "Grabación de audio",
		"share_trans_text": "Transcripción",
		"share_summny_text": "Resumen",
		"share_map": "Mapa mental",
		"share_url_pw": "Cifrado de acceso",
		"share_random_pw": "Contraseña generada aleatoriamente",
		"share_url_copy": "Copiar enlace",
		"share_url_copy_success": "El enlace de copia fue exitoso",
		"share_link_pw": "Contraseña de acceso",
		"share_copy_success": "¡La transcripción ha sido copiada al portapapeles!",
		"share_copy_success2": "Se ha copiado el resumen a la tabla de cortar!",
		"share_speaker": "Orador",
		"share_no_update_speaker": "No se puede editar. El orador está vacío",
		"share_no_trans": "Sin transcripción",
		"share_no_summny": "No resumen",
		"share_no_map": "Sin contenido en el mapa",
		"share_trans_text_1": "Transcripción",
		"share_summny_text_1": "Resumen",
		"share_map_1": "Mapa",
		"share_save": "Guardado correctamente",
		"share_no_map": "Imagen del mapa no generada",
		"share_update_text": "Editar el texto de la transcripción",
		"share_update_text2": "Editar el texto del resumen",
		"showLoading": "cargando...",
		"handwriting": "Contenido manuscrito",
		"handwritingText": "Escritura a mano",
		"share_1": "No se reconoce el contenido escrito a mano en esta página",
		"share_2": "Editar reconocimiento de escritura a mano",
		"share_3": "Reconocimiento de escritura a mano",
		"share_4":"Se está exportando el archivo, no salga de esta página",
		"folder_text":"Carpeta",
		"folder_text_update_name":"Rebautizar",
		"folder_text_del":"borrar",
		"folder_text_all":"todo",
		"folder_text_type":"tipo de archivo",
		"folder_text_audio":"Notas de voz",
		"folder_text_writing":"Notas manuscritas",
		"folder_text_file_type":"tipo de archivo",
		"folder_text_add":"Nueva carpeta",
		"folder_text_input_name":"Por favor, introduzca un nombre",
		"folder_text_cancel":"Cancelar",
		"folder_text_summit":"confirmar",
		"folder_text_name_not_null":"El nombre no puede estar vacío.",
		"folder_text_add_success":"¡Creación exitosa!",
		"folder_text_del_confirm":"Eliminar confirmación",
		"folder_text_confirm":"¿Seguro que quieres eliminar la carpeta seleccionada? Tras la eliminación, las notas de la carpeta se moverán a la papelera de reciclaje.",
		"folder_text_del_success":"¡Eliminación exitosa!",
		"folder_text_move":"Convidar a",
		"folder_text_move_success":"¡Movimiento exitoso!",
		"folder_update_name":"Carpeta renombrada",
		"folder_text_update_success":"¡Modificación exitosa!",
		"empty_text":"No hay datos disponibles",
		"trans_text_null": "El texto transcrito no puede estar vacío",
		"summary_text_null": "El resumen no puede estar vacío",
		"please_create_folder":"Por favor, cree una carpeta primero"
	}
}